exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#tDiasHoras[data-v-899c8296] {\n  border-collapse: collapse;\n  width: 100%;\n}\n#tDiasHoras td[data-v-899c8296],\n#tDiasHoras th[data-v-899c8296] {\n  border: 1px solid #ddd;\n  padding: 8px;\n  font-weight: 500;\n}\n#tDiasHoras tr[data-v-899c8296]:nth-child(even) {\n  background-color: #f2f2f2;\n}\n.selecciona[data-v-899c8296] {\n  background-color: rgb(12, 3, 131);\n}\n#tDiasHoras th[data-v-899c8296] {\n  padding-top: 12px;\n  padding-bottom: 12px;\n  text-align: center;\n  color: rgba(0, 0, 0, 0.54);\n}\n", ""]);

// exports
